
/**
 *
 * @description 创建合并行列需要的数据，在table数据更新变化时调用
 * @export
 * @param {*} formatDataResult
 * @param {*} coreInstance
 * @return {*}
 */
export function mergeFixedRowsCellsData(formatDataResult, coreInstance) {
  coreInstance.store.clearfixedRowsMergedCellsMap()
  coreInstance.store.clearfooterRowsMergedCellsMap()
  const { getfooterRowsMergedCellsMap, getfixedRowsMergedCellsMap } = coreInstance.store
  const { mergeFixedRowsEqualCellsOption, mergeFooterRowsEqualCellsOption } = coreInstance.table.$props
  if (mergeFixedRowsEqualCellsOption) {
    const fixedRowsData = (coreInstance.table.$props.fixedRowsTop ? formatDataResult.tableData.slice(0, coreInstance.table.$props.fixedRowsTop) : coreInstance.table.$props.fixedRowsData)
    getfixedRowsMergedCellsMap(fixedRowsData)

  }
  if (mergeFooterRowsEqualCellsOption) {
    getfooterRowsMergedCellsMap(coreInstance.table.$props.footerRows)
  }
  return formatDataResult
}







// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/config/fixed-footer-merge-cell.js